import React from "react";
import { connect } from "react-redux";
import { IAppState } from "..";
import { userService } from "../../User";

type Props = {
  date: Date;
  isOverdue?: boolean;
};

type StateProps = {
  utcOffset: number;
};

function mapStateToProps(state: IAppState): StateProps {
  return {
    utcOffset: userService.getUtcOffset(state.oidc)
  };
}

class DateDisplay extends React.Component<Props & StateProps> {
  render() {
    const { date, isOverdue } = this.props;

    const style = isOverdue ? { color: "red" } : {};

    return <span style={style}>{date.toLocaleString()}</span>;
  }
}

export default connect(mapStateToProps)(DateDisplay);
